import styled, { keyframes } from 'vue3-styled-components';

export const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const FeedbackContainer = styled.div`
  position: relative;
  display: inline-flex;
  z-index: 1;
`;

export const FeedbackPreviewContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 200px;
`;

export const FeedbackPreviewMessage = styled.p`
    margin: 0;
    color: #4a5568;
    font-size: 14px;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
`;

export const PreviewMoreIcon = styled.div`
    color: #0f4c5c;
    opacity: 0.7;
    margin-left: 6px;
    display: flex;
    align-items: center;
    
    svg {
        width: 20px;
        height: 20px;
    }
`;

export const FeedbackTrigger = styled.div`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 5px 16px;
    background: linear-gradient(145deg, #ffffff, #f0f0f0);
    border-radius: 10px;
    box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
    transition: all 0.3s ease;
    border: 2px solid #0f4c5c;
    position: relative;
    width: auto;
    
    .feedback-preview {
        display: flex;
        align-items: center;
        gap: 8px;
        max-width: fit-content;
    }

    &:hover {
        transform: translateY(-2px);
        box-shadow: 6px 6px 12px #d9d9d9, -6px -6px 12px #ffffff;
    }
`;

export const FeedbackCount = styled.div`
  position: absolute;
  top: -10px;
  left: -10px;
  width: 27px;
  height: 27px;
  background: linear-gradient(145deg, #ff4757, #ff6b81);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(255, 71, 87, 0.3);
  border: 2px solid #ffffff;
`;

export const FeedbackIcon = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f4c5c;
  display: inline-flex;
`;

export const FeedbackText = styled.span`
  color: #0f4c5c;
  font-weight: 500;
  font-size: 14px;
  display: inline-flex;
`;

export const FeedbackDefault = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const FeedbackPopup = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: 380px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  animation: ${slideDown} 0.3s ease;
`;

export const FeedbackHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: linear-gradient(145deg, #0f4c5c, #1a6985);
  color: white;
`;

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SortButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  color: white;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-1px);
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateY(-1px);
  }
`;

export const HeaderTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  &:hover {
    transform: rotate(90deg);
  }
`;

export const FeedbackContent = styled.div`
  position: relative;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(145deg, #0f4c5c, #1a6985);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #0f4c5c;
  }
`;

export const FeedbackItem = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #eef2f7;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f8fafc;
  }

  &.unread {
    background: linear-gradient(145deg, #f8fafc, #eef2f7);
    border-left: 4px solid #0f4c5c;
  }
`;

export const FeedbackItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const FeedbackUser = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 1;
`;

export const UserAvatar = styled.div`
    color: #0f4c5c;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const FeedbackAuthor = styled.span`
    font-weight: 600;
    color: #2d3748;
    font-size: 14px;
`;

export const FeedbackDate = styled.span`
  color: #a0aec0;
  font-size: 12px;
`;

export const FeedbackMessage = styled.p`
  margin: 0;
  color: #4a5568;
  line-height: 1.6;
  font-size: 14px;
  white-space: pre-line;
`;

export const FeedbackActions = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const ActionButton = styled.button`
  background: none;
  border: 1px solid #0f4c5c;
  color: #0f4c5c;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;

  &.read {
    border-color: #0f4c5c;
    color: #0f4c5c;
    &:hover {
      background: #0f4c5c;
      color: white;
    }
  }

  &.unread {
    border-color: #718096;
    color: #718096;
    &:hover {
      background: #718096;
      color: white;
    }
  }

  &.order {
    border-color: #4299e1;
    color: #4299e1;
    &:hover {
      background: #4299e1;
      color: white;
    }
  }
`;

export const FeedbackFooter = styled.div`
  padding: 16px;
  text-align: center;
  background: #f8fafc;
  border-top: 1px solid #eef2f7;
`;

export const LoadMoreButton = styled.button`
  background: none;
  border: none;
  color: #0f4c5c;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 auto;
  transition: all 0.2s ease;

  &:hover {
    background: #eef2f7;
  }
`;

export const EmptyFeedback = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #a0aec0;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  svg {
    color: #cbd5e0;
    width: 48px;
    height: 48px;
  }
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  color: #0f4c5c;
`;

export const FeedbackTitle = styled.h4`
    margin: 0 0 8px 0;
    color: #2d3748;
    font-size: 15px;
    font-weight: 600;
`;

export const FeedbackMessageWrapper = styled.div`
    margin-top: 8px;
    border-radius: 8px;
`;